export const STARTING_PROMPT_GROUPS: string[][] = [
  [
    'Explain the Amount threshold rule',
    'What does the Adverse media rule check?',
    'What happens after a rule triggers?',
    'What is the difference between a ping and a case?',
  ],
  [
    'How has the number of new cases changed over the last 90 days?',
    'Summarise the oldest unassigned open case',
    'Summarise the newest case and what triggered it',
    'What was the largest transaction this week, and how was it handled?',
  ],
  [
    'How do I create a new rule?',
    'How do I add an individual manually?',
    'How do I create a report?',
    'How do I set up a risk class?',
  ],
];

export const pickStartingPrompts = (random: () => number): string[] => STARTING_PROMPT_GROUPS.map(
  (prompts) => prompts[Math.floor(random() * prompts.length)],
);
